module.exports = __webpack_public_path__ + "static/media/14_crisalide.39c57a99.jpg";